import
  React, {
  Suspense,
} from 'react';

import
  styled
from 'styled-components';

import {
  Loader,
} from 'common/components/Loader';

const Fallback = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LazyRoute = ({
  component: Component,
  ...props
}) => (

  <Suspense
    fallback={(
      <Fallback>
        <Loader />
      </Fallback>
    )}>

    <Component {...props} />

  </Suspense>
);

export const lazyRoute = (Component) => {

  const RouteComponent = (props) => (

    <LazyRoute
      component={Component}
      {...props}
    />
  );

  const name = Component.displayName || Component.name || 'Component';
  RouteComponent.displayName = `LazyRoute(${name})`;

  return RouteComponent;
};
